/** 角色常量（与后端 RoleConstants 一致） */
export const ROLES = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    USER: 'USER',
};

export const ROLE_LABEL = {
    SUPER_ADMIN: '超级管理员',
    ADMIN: '管理员',
    USER: '普通用户',
};

export const ROLE_TAG_COLOR = {
    SUPER_ADMIN: 'gold',
    ADMIN: 'blue',
    USER: 'default',
};

export const getRoleLabel = (roleKey) =>
    ROLE_LABEL[roleKey] || roleKey || '—';

/** 展示用角色名：始终以 roleKey 映射为准，避免后端 roleName 编码乱码 */
export const displayRoleName = (record) => {
    if (record?.roleKey) {
        return getRoleLabel(record.roleKey);
    }
    return '—';
};

export const isSuperAdmin = (user) => user?.roleKey === ROLES.SUPER_ADMIN;

export const isAdmin = (user) => user?.roleKey === ROLES.ADMIN;

export const isNormalUser = (user) => user?.roleKey === ROLES.USER;

/** 可进入用户管理菜单 / 列表 */
export const canManageUsers = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可授权 / 撤销管理员 */
export const canGrantAdmin = (user) => isSuperAdmin(user);

/** 可显示「添加用户」 */
export const canCreateUser = (user) => canManageUsers(user);

/** 创建用户时可选择角色（仅超管） */
export const canChooseRoleOnCreate = (user) => isSuperAdmin(user);

/** 是否可编辑目标用户 */
export const canEditUser = (operator, target) => {
    if (!operator || !target) return false;
    if (operator.id === target.id) return true;
    if (target.roleKey === ROLES.SUPER_ADMIN) return false;
    if (isSuperAdmin(operator)) return true;
    if (isAdmin(operator)) return target.roleKey === ROLES.USER;
    return false;
};

/** 是否可删除目标用户 */
export const canDeleteUser = (operator, target) => {
    if (!operator || !target) return false;
    if (operator.id === target.id) return false;
    if (target.roleKey === ROLES.SUPER_ADMIN) return false;
    if (isSuperAdmin(operator)) return true;
    if (isAdmin(operator)) return target.roleKey === ROLES.USER;
    return false;
};

/** 是否可修改目标用户状态（超管账号不可改状态） */
export const canChangeStatus = (operator, target) => {
    if (!target) return false;
    if (target.roleKey === ROLES.SUPER_ADMIN) return false;
    return canEditUser(operator, target);
};

/** 可浏览视频库（所有登录用户，列表内容按角色过滤） */
export const canBrowseVideos = () => true;

/** 可扫描视频入库 */
export const canScanVideos = (user) => isSuperAdmin(user);

/** 可分配/撤销视频观看权 */
export const canAssignVideo = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可软删视频记录 */
export const canDeleteVideo = (user) => isSuperAdmin(user);

/** 可查看某视频的已分配用户列表 */
export const canViewVideoAccess = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可设置视频分类/标签 */
export const canSetVideoMeta = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可管理视频分类/标签字典（仅超管） */
export const canManageVideoDict = (user) => isSuperAdmin(user);

/** 可浏览图片库（所有登录用户，列表内容按角色过滤） */
export const canBrowseImages = () => true;

/** 可扫描图片入库 */
export const canScanImages = (user) => isSuperAdmin(user);

/** 可分配/撤销图片浏览权 */
export const canAssignImage = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可软删图片记录 */
export const canDeleteImage = (user) => isSuperAdmin(user);

/** 可查看某图片的已分配用户列表 */
export const canViewImageAccess = (user) => isSuperAdmin(user) || isAdmin(user);

/** 可浏览基金与资讯（所有登录用户） */
export const canBrowseFunds = () => true;

/** 可管理系统配置（对接文档 v2.17：/api/system/config 仅 SUPER_ADMIN） */
export const canManageSystemConfig = (user) => isSuperAdmin(user);
